import type { FC } from "react";
import classNames from "classnames";
import type { IconProps } from "./Icon.types";

function iconName({ name, children }: Pick<IconProps, "name" | "children">) {
    return name ?? children;
}

export const Icon: FC<IconProps> = ({ name, children, scale = 1.75 }) => (
    <i
        className={classNames(
            "icon",
            `icon-${iconName({ name, children })}`,
            scale && `icon--${scale}x`
        )}
    />
);
